import React from 'react'
import {Message} from 'data/types'
import {Col, Row} from './Display'
import UserAvatar from './UserAvatar'
import moment from 'moment'

type ChatMessageProps = {
  message: Message
}

export default function ChatMessage(props: ChatMessageProps) {
  return (
    <Row>
      <Col>
        <UserAvatar user={props.message.user} />
      </Col>
      <Col className="pl-2">
        <Row className="items-center">
          <div className="text-sm font-semibold">
            {props.message.user.firstName} {props.message.user.lastName}
          </div>
          <div className="text-sm text-itx-gray-dark pl-2">{moment(props.message.createdAt).fromNow()}</div>
        </Row>
        <div className="whitespace-pre-line text-base font-normal break-all">{props.message.text.replace(/↵/gi, '\n')}</div>
      </Col>
    </Row>
  )
}
